import RedirectComponent from './components/Redirect';

export default (store) => ({
  component: RedirectComponent,
});



// WEBPACK FOOTER //
// ./src/routes/magic/routes/SettleMagicLinkRoute/index.js